/* eslint-disable angular/factory-name */

(function iife() {
	"use strict";

	angular.module("dx.webapp.validation").factory("passwordValidationService", PasswordValidationService);

	function PasswordValidationService(
		PasswordValidationErrorEnum
	) {
		var whiteSpaceRegex = /\s+/;

		return {
			validate: function validate(password) {
				if (!password || password.length < 8) {
					return PasswordValidationErrorEnum.TOO_SHORT;
				}

				if (password.length > 100) {
					return PasswordValidationErrorEnum.TOO_LONG;
				}

				if (whiteSpaceRegex.test(password)) {
					return PasswordValidationErrorEnum.CONTAINS_WHITESPACE;
				}

				return PasswordValidationErrorEnum.NONE;
			},
		};
	}
}());
